import React, { useRef, useState, useEffect } from "react"
import { useAuthDataContext } from "../../../../../_providers/Auth"
import Api from "../../../../../_helpers/Api"
import Modal from "./modals/Integrations"
import Skeleton from "react-loading-skeleton"
import { trans } from "@/_providers/Translation"

const ENDPOINT = "https://eusystem.eu/auth"

const METHOD_COLORS = {
  GET: "#0f9d58",
  POST: "#4285f4",
  PUT: "#f4b400",
  DELETE: "#db4437",
}

const MODULES = [
  {
    id: "create-reservation",
    title: "api.modules.createReservation.title",
    description: "api.modules.createReservation.description",
    method: "POST",
    endpoint: "https://service.eus.tech/external-api/reservations/create",
    params: [
      {
        name: "appliance_category_id",
        type: "integer",
        required: true,
        desc: "api.params.applianceCategoryId",
      },
      {
        name: "appliance_brand_id",
        type: "integer",
        required: true,
        desc: "api.params.applianceBrandId",
      },
      {
        name: "lat",
        type: "decimal",
        required: true,
        desc: "api.params.lat",
      },
      {
        name: "lon",
        type: "decimal",
        required: true,
        desc: "api.params.lon",
      },
      {
        name: "address",
        type: "string",
        required: true,
        desc: "api.params.address",
      },
      {
        name: "phone",
        type: "string",
        required: true,
        desc: "api.params.phone",
      },
      {
        name: "visit_date",
        type: "string",
        required: true,
        desc: "api.params.visitDate",
      },
      {
        name: "visit_period_id",
        type: "string",
        required: true,
        desc: "api.params.visitPeriodId",
      },
      {
        name: "postcode",
        type: "string",
        required: true,
        desc: "api.params.postcode",
      },
      {
        name: "product_code",
        type: "string",
        required: true,
        desc: "api.params.productCode",
      },
      {
        name: "name",
        type: "string",
        required: true,
        desc: "api.params.name",
      },
      {
        name: "lastname",
        type: "string",
        required: true,
        desc: "api.params.lastname",
      },
    ],
    response: `{
    "reference_code": "170720262",
    "visit_date": "2026-07-21",
    "visit_period_id": 1,
    "address": "ul. Ivan Vazov 10, Sofia",
    "currency": {
        "id": 3,
        "name": "EUR",
        "default": 1,
        "rate": 0.51
    },
    "transport_price": 0,
    "transport_price_formatted": "0.00",
    "diagnostic_price": 0,
    "diagnostic_price_formatted": "0.00",
    "labour_price": 55,
    "labour_price_formatted": "55.00"
}`,
  },
  {
    id: "live-tracking",
    title: "api.modules.liveTracking.title",
    description: "api.modules.liveTracking.description",
    method: "GET",
    endpoint: "https://service.eus.tech/external-api/reservations/track",
    params: [
      {
        name: "ref",
        type: "string",
        required: true,
        desc: "api.params.ref",
      },
    ],
    response: `{
    "ref": "170720261",
    "date": "2026-07-21",
    "visit_period": "09:30-10:15",
    "address": "ul. Ivan Vazov 10, Sofia",
    "lat": "42.69770000",
    "lon": "23.32190000",
    "status": "Diagnostic",
    "employee": null,
    "employee_id": null,
    "partner_id": 150,
    "is_employee_travels": false,
    "employee_lat": null,
    "employee_lon": null,
    "remaining_time_to_visit": null,
    "parts": []
},
  "updated_at": "2026-07-17T09:32:00Z"
}`,
  },
  {
    id: "brands-list",
    title: "api.modules.brandsList.title",
    description: "api.modules.brandsList.description",
    method: "GET",
    endpoint: "https://service.eus.tech/external-api/reservations/brands",
    params: [],
    response: `[
    {
        "id": 1,
        "name": "Bosch"
    },
    {
        "id": 2,
        "name": "LG"
    },
    {
        "id": 4,
        "name": "test"
    }
]`,
  },
  {
    id: "categories-list",
    title: "api.modules.categoriesList.title",
    description: "api.modules.categoriesList.description",
    method: "GET",
    endpoint: "https://service.eus.tech/external-api/reservations/categories",
    params: [],
    response: `[
    {
        "id": 1,
        "name": "Кафе машина"
    },
    {
        "id": 2,
        "name": "Пералня"
    },
    {
        "id": 3,
        "name": "телевизор"
    }
]`,
  },
  {
    id: "work-days-list",
    title: "api.modules.workDaysList.title",
    description: "api.modules.workDaysList.description",
    method: "GET",
    endpoint: "https://service.eus.tech/external-api/reservations/work-days",
    params: [],
    response: `[
    "1",
    "2",
    "3",
    "5",
    "6",
    "7"
]`,
  },
  {
    id: "visit-periods-list",
    title: "api.modules.visitPeriodsList.title",
    description: "api.modules.visitPeriodsList.description",
    method: "GET",
    endpoint:
      "https://service.eus.tech/external-api/reservations/visit-periods",
    params: [],
    response: `[
    {
        "id": 1,
        "from": "09:30:00",
        "to": "10:15:00"
    },
    {
        "id": 2,
        "from": "10:30:00",
        "to": "10:45:00"
    },
    {
        "id": 3,
        "from": "11:00:00",
        "to": "12:00:00"
    },
    {
        "id": 8,
        "from": "12:00:00",
        "to": "13:00:00"
    },
    {
        "id": 4,
        "from": "13:00:00",
        "to": "14:00:00"
    },
    {
        "id": 5,
        "from": "15:00:00",
        "to": "15:45:00"
    },
    {
        "id": 6,
        "from": "16:00:00",
        "to": "16:45:00"
    },
    {
        "id": 7,
        "from": "17:00:00",
        "to": "17:45:00"
    }
]`,
  },
]

function ApiModule({ module }) {
  return (
    <div className="pannel" style={{ marginBottom: 20 }}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <div>
          <h3 style={{ margin: 0, fontSize: 18, color: "#262f5f" }}>
            {trans(module.title)}
          </h3>
          <p
            style={{
              margin: "6px 0 0",
              color: "#7c86a2",
              fontSize: 13,
              lineHeight: 1.4,
            }}
          >
            {trans(module.description)}
          </p>
        </div>
      </div>

      {/* Endpoint bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginTop: 16,
          padding: "10px 14px",
          background: "#f5f7fb",
          border: "1px solid #e0e5f2",
          borderRadius: 10,
        }}
      >
        <span
          style={{
            display: "inline-block",
            minWidth: 54,
            textAlign: "center",
            padding: "4px 10px",
            borderRadius: 6,
            background: METHOD_COLORS[module.method] || "#4285f4",
            color: "#fff",
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0.5,
          }}
        >
          {module.method}
        </span>
        <code
          style={{
            fontFamily: "'Roboto Mono', Consolas, monospace",
            fontSize: 14,
            wordBreak: "break-all",
          }}
        >
          {module.endpoint}
        </code>
      </div>

      {/* Parameters */}
      {module.params.length ? (
        <div style={{ marginTop: 20 }}>
          <h5
            style={{
              fontSize: 13,
              textTransform: "uppercase",
              letterSpacing: 0.6,
              color: "#7c86a2",
              margin: "0 0 10px",
            }}
          >
            {trans("api.parameters")}
          </h5>
          <div
            style={{
              border: "1px solid #e0e5f2",
              borderRadius: 10,
              overflow: "hidden",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: 13,
              }}
            >
              <thead>
                <tr style={{ background: "#f5f7fb" }}>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "8px 14px",
                      color: "#7c86a2",
                      fontWeight: 600,
                      borderRadius: 0,
                    }}
                  >
                    {trans("api.name")}
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "8px 14px",
                      color: "#7c86a2",
                      fontWeight: 600,
                    }}
                  >
                    {trans("api.type")}
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "8px 14px",
                      color: "#7c86a2",
                      fontWeight: 600,
                    }}
                  >
                    {trans("api.required")}
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "8px 14px",
                      color: "#7c86a2",
                      fontWeight: 600,
                      borderRadius: 0,
                    }}
                  >
                    {trans("api.description")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {module.params.map((param, i) => (
                  <tr
                    key={param.name}
                    style={{
                      borderTop: "1px solid #e0e5f2",
                      background: i % 2 ? "#fbfcfe" : "#fff",
                    }}
                  >
                    <td style={{ padding: "8px 14px" }}>
                      <code
                        style={{
                          fontFamily: "'Roboto Mono', Consolas, monospace",
                          color: "#3a61ff",
                          fontWeight: 600,
                        }}
                      >
                        {param.name}
                      </code>
                    </td>
                    <td style={{ padding: "8px 14px", color: "#7c86a2" }}>
                      {param.type}
                    </td>
                    <td style={{ padding: "8px 14px" }}>
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 600,
                          padding: "2px 8px",
                          borderRadius: 20,
                          background: param.required ? "#fdecea" : "#eef1f7",
                          color: param.required ? "#db4437" : "#7c86a2",
                        }}
                      >
                        {param.required
                          ? trans("api.requiredBadge")
                          : trans("api.optionalBadge")}
                      </span>
                    </td>
                    <td style={{ padding: "8px 14px", color: "#262f5f" }}>
                      {trans(param.desc)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <></>
      )}

      {/* Example response */}
      <div style={{ marginTop: 20 }}>
        <h5
          style={{
            fontSize: 13,
            textTransform: "uppercase",
            letterSpacing: 0.6,
            color: "#7c86a2",
            margin: "0 0 10px",
          }}
        >
          {trans("api.exampleResponse")}
        </h5>
        <pre
          style={{
            margin: 0,
            padding: "16px 18px",
            background: "#1e2233",
            color: "#e6e9f5",
            borderRadius: 10,
            fontFamily: "'Roboto Mono', Consolas, monospace",
            fontSize: 13,
            lineHeight: 1.5,
            overflowX: "auto",
          }}
        >
          <code style={{ color: "#fff" }}>{module.response}</code>
        </pre>
      </div>
    </div>
  )
}

function API(props) {
  const auth = useAuthDataContext()

  const modalRef = useRef(null)

  const [state, setState] = useState({
    loading: true,
    data: [],
    update: false,
  })

  useEffect(() => {
    loadSettings()
  }, [state.update])

  const loadSettings = () => {
    Api.get("partners/settings/all?id=" + auth.user().partner_id)
      .then((res) => {
        setState((prev) => ({
          ...prev,
          loading: false,
          data: res.data,
        }))
      })
      .catch(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }))
      })
  }

  const handleUpdate = () => {
    setState((prev) => ({
      ...prev,
      update: new Date().getTime(),
    }))
  }

  const showModal = () => {
    let modal = modalRef.current

    modal.show(state.data)

    modal.onSave(() => {
      handleUpdate()

      if (typeof props.handleRefresh === "function") {
        props.handleRefresh()
      }
    })
  }

  return (
    <div style={{ width: "100%" }}>
      <h3
        style={{
          marginBottom: 0,
        }}
      >
        {trans("api.heading")}
      </h3>
      <hr />

      <div
        className="alert info"
        style={{
          marginBottom: 0,
          width: "100%",
        }}
      >
        {trans("api.moduleDesc")}
      </div>
      <br />
      {state.loading ? (
        <Skeleton height={35} count={2} />
      ) : (
        <>
          {/* API key */}
          <div
            className="pannel"
            style={{
              marginBottom: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            <div>
              <h5
                style={{
                  fontSize: 13,
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                  color: "#7c86a2",
                  margin: "0 0 6px",
                }}
              >
                {trans("api.apiKey")}
              </h5>
              <code
                style={{
                  fontFamily: "'Roboto Mono', Consolas, monospace",
                  fontSize: 14,
                  color: "#262f5f",
                  wordBreak: "break-all",
                }}
              >
                {state.data.external_api_key
                  ? state.data.external_api_key
                  : trans("labels.notSpecified")}
              </code>
            </div>

            <div
              className="alert warning"
              style={{
                marginBottom: 0,
                width: "100%",
              }}
            >
              {trans("api.instructions")}
              <br />
              <br /> {trans("api.example")}
              <br />
              <br />
              <pre
                style={{
                  margin: 0,
                  padding: "16px 18px",
                  background: "#1e2233",
                  color: "#e6e9f5",
                  borderRadius: 10,
                  fontFamily: "'Roboto Mono', Consolas, monospace",
                  fontSize: 13,
                  lineHeight: 1.5,
                  overflowX: "auto",
                }}
              >
                <code
                  style={{
                    fontFamily: "'Roboto Mono', Consolas, monospace",
                    fontSize: 14,
                    wordBreak: "break-all",
                    color: "#fff",
                  }}
                >
                  {`axios.get("https://service.eus.tech/external-api/example-endpoint", {
  headers: {
    "X-Api-Key": "${state.data.external_api_key}"
  }
})`}
                </code>
              </pre>
            </div>
          </div>

          {/* Modules */}
          {MODULES.map((module) => (
            <ApiModule key={module.id} module={module} />
          ))}
        </>
      )}
    </div>
  )
}

export default API
